import toast from "react-hot-toast";
import { handleVisitoExport } from "../Timeline/VisitorExport";

export const useVisitorActions = ({
  setSignOut,
  setDeleteRow,
}: {
  setSignOut: (v: boolean) => void;
  setDeleteRow: (v: boolean) => void;
}) => {
  const handleActionSelect = async (
    action: { id: string },
    visitors: any[],
    selectedRows: any[]
  ) => {
    switch (action.id) {
      case "Export":
        try {
          const headers = [
            "Visitor Name",
            "Category",
            "Host",
            "Status",
            "Signed In",
            "Signed Out",
            "Duration",
          ];

          await handleVisitoExport(headers, visitors, selectedRows, "Visitor");
          toast.success("Visitor report exported successfully!");
        } catch (err) {
          console.error(err);
          toast.error("Failed to export Excel file");
        }
        break;

      case "Out":
        setSignOut(true);
        break;

      case "Anonymize":
        setDeleteRow(true);
        break;

      default:
        break;
    }
  };

  return { handleActionSelect };
};
